var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-tag-container" },
    [
      _c(
        "div",
        {
          staticClass: "custom-tag",
          class: {
            active: _vm.computedIsActive,
            "has-value": _vm.value && _vm.value.trim(),
            "show-input": _vm.showInput,
          },
          on: { click: _vm.handleTagClick },
        },
        [
          _c("span", { staticClass: "tag-label" }, [
            _vm._v(_vm._s(_vm.searchValue || _vm.label)),
          ]),
          _vm.closable && (_vm.searchValue || (_vm.value && _vm.value.trim()))
            ? _c(
                "span",
                {
                  staticClass: "tag-close",
                  attrs: { title: "清除" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleCloseClick.apply(null, arguments)
                    },
                  },
                },
                [_c("Icon", { attrs: { type: "md-close", size: "12" } })],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm.showInput && _vm.mode === "input"
        ? _c("Input", {
            ref: "inputRef",
            staticClass: "tag-input",
            attrs: { placeholder: _vm.placeholder, size: "small" },
            on: { blur: _vm.handleInputBlur },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleInputEnter.apply(null, arguments)
              },
            },
            model: {
              value: _vm.inputValue,
              callback: function ($$v) {
                _vm.inputValue = $$v
              },
              expression: "inputValue",
            },
          })
        : _vm._e(),
      _vm.showInput && _vm.mode === "select"
        ? _c(
            "Select",
            {
              ref: "selectRef",
              staticClass: "tag-input tag-select",
              attrs: {
                filterable: "",
                placeholder: _vm.placeholder,
                size: "small",
              },
              on: {
                "on-change": _vm.handleSelectChange,
                "on-open-change": _vm.handleSelectOpenChange,
              },
              model: {
                value: _vm.inputValue,
                callback: function ($$v) {
                  _vm.inputValue = $$v
                },
                expression: "inputValue",
              },
            },
            _vm._l(_vm.localOptions, function (option, index) {
              return _c(
                "Option",
                {
                  key: index,
                  attrs: { value: option.value, label: option.label },
                },
                [_vm._v("\n            " + _vm._s(option.label) + "\n        ")]
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }